import { createI18n } from 'vue-i18n';

import { getBrowserLocale } from '@/utils/browserLangDetector.util';

import { fr } from './fr';

const translates = {
  fr,
};

const langPref = () => {
  const navigatorLocal = getBrowserLocale();
  if (navigatorLocal !== null && Object.keys(translates).includes(navigatorLocal)) {
    return navigatorLocal;
  }
  return 'fr';
};

export const i18n = createI18n({
  legacy: false,
  locale: langPref(),
  fallbackLocale: langPref(),
  messages: translates,
});
